module.exports = __webpack_public_path__ + "img/Subtract.0dfcf790.png";